import parent from '@/config/menus/configurationsSedes'
// import store from '@/store'

export default (params) => {
  const menu = parent({ ...params, issuingCreation: false })
  if (params.issuingCreation) {
    const admCentersIndex = menu[0].sc.findIndex(x => x.path === 'masters/society/locations/administrativecenters')
    menu[0].sc = menu[0].sc.slice(admCentersIndex, admCentersIndex + 1)
  }
  return menu
}
